<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EI8z34/tc-custom/9780897336628.jpg?1737918819384" alt="This image is the cover for the book Honeywood Settlement"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Honeywood Settlement
      </h1>
      <p class="bookDescription body article font2">
        <b>A sequel to the “British comedy classic . . . revealing a great deal of still-pertinent information about house-building” (<i>The Globe and Mail</i>).</b><br/>  <br/> A sequel to <i>The Honeywood File</i>, originally published in 1929, <i>The Honeywood Settlement</i> takes the form of an epistolary novel. Some of the great comic characters inhabit the pages of this book, and like all comedy, their stories contain more than a grain of truth. The book tells, in the form of letters gleaned from an architect's files, the excitements and disasters of designing and building a large country house, with the painful aftermath of clearing up the defects and haggling over the bill. What makes this book so enjoyable and instructive is the clever interplay of all the diverse characters in the drama, and the author's sagacious and witty running commentary on their performance. The main protagonists are the hapless young architect James Spinlove; Sir Leslie Brash, his peppery and pompous client; the honest John Grigblay, the builder whose down-to-earth common sense gets the job done despite difficulties. Plus a cast of glorious inventions as Hoochcraft, Potch, Nibnose &amp; Rasper, and Beddy &amp; Tinge, quantity surveyors.<br/>  <br/> Praise for <i>The</i><i>Honeywood File</i><i>:</i><br/>  <br/> “Full of human nature; and full of useful information lightly conveyed, for everybody concerned with domestic architecture.” —Arnold Bennett, author of <i>Anna of the Five Towns </i>and<i> How To Live on 24 Hours a Day</i><br/>  <br/> “Recommended to the earnest study of all young architects and all those temerarious enough to desire to build their own houses.” —<i>The </i><i>Burlington</i><i>Magazine</i><br/>  <br/> “I have admired <i>The Honeywood File</i> and <i>The Honeywood Settlement</i> . . . since I was told about them as an architecture student, and never ceased to feel grateful to the lecturer who introduced them to me.” —Leslie Fairweather, architect and former editor of <i>Architects’ Journal</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H.B. Creswell
      </h2>
      
      <p class="authorDescription body article">H.B. Creswell's books include Grig, Grig in Retirement, and Thomas. He was an architect who lived in England in the 1920s and 1930s.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Academy Chicago Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?73943756